export function printArticle() {
    $('.print').on('click', function (e) {
        window.print();
        e.preventDefault();
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/printArticle.js